import loadingFailed from '../assets/loading_failed.svg'
import { ChartItem } from './ChartItem'

interface ChartItemData {
  date: string
  value: string | number
  amount: string | number
  barHeight: number
}

interface WeeklyEarningsChartProps {
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  displayData: ChartItemData[]
  shouldShowEmptyState: boolean
  onReload: () => void
}

export function WeeklyEarningsChart({
  isLoading,
  isFetching,
  isError,
  displayData,
  shouldShowEmptyState,
  onReload,
}: WeeklyEarningsChartProps) {
  const showLoading = isLoading || (isError && isFetching)

  return (
    <div
      className='mt-[37px] flex w-full flex-col gap-[36px]'
      data-testid='last-7days-section'
    >
      <p
        className='font-black text-[16px] leading-normal text-[#111] not-italic'
        data-testid='last-7days-title'
      >
        Last 7 Days Earnings
      </p>

      <div className='flex w-full justify-center'>
        {isError && !isFetching ? (
          <div
            className='flex w-full flex-col items-center justify-center gap-[24px] py-[40px]'
            data-testid='chart-error-state'
          >
            <img src={loadingFailed} alt='' className='h-[160px] w-[160px]' />
            <div className='flex flex-col items-center gap-[8px]'>
              <p
                className='font-semibold text-[18px] leading-normal text-[#1a1a1a] not-italic'
                data-testid='error-title'
              >
                Unable to load the page
              </p>
              <p
                className='font-normal text-[14px] leading-normal text-[#999] not-italic'
                data-testid='error-subtitle'
              >
                Tap to retry
              </p>
            </div>
            <button
              onClick={onReload}
              className='flex h-[48px] w-[200px] items-center justify-center rounded-[24px] bg-[#F4EFFF] font-semibold text-[16px] leading-normal text-[#8162DA] not-italic hover:bg-[#E8DEFF]'
              data-testid='chart-reload-button'
            >
              Reload
            </button>
          </div>
        ) : (
          <div className='flex items-end gap-[14px]'>
            {(showLoading ? Array.from({ length: 7 }) : displayData).map(
              (_, index) => {
                const item = showLoading ? null : displayData[index]
                return (
                  <ChartItem
                    key={showLoading ? index : item?.date}
                    index={index}
                    isLoading={showLoading}
                    isEmpty={shouldShowEmptyState}
                    date={item?.date}
                    value={item?.value}
                    amount={Number(item?.amount)}
                    barHeight={item?.barHeight}
                  />
                )
              },
            )}
          </div>
        )}
      </div>
    </div>
  )
}
